export const ALL = 'all';

export const PATHS = {
  EMPTY: '',
  FORM: 'form',
  COMPLETED: 'completed',
};

export const FORM_FIELDS = {
  FIRST_NAME: 'first_name',
  LAST_NAME: 'last_name',
  EMAIL_ADDRESS: 'email_address',
  COUNTRY_OF_RESIDENCE: 'country_of_residence',
  MAIN_GENRE: 'main_genre',
  PROFILE_STATEMENT: 'profile_statement',
  PHOTO_SKILLS: 'photo_skills',
  VIDEO_SKILLS: 'video_skills',
  PRINT_STATEMENT: 'print_statement',
  PHOTO_CAPTION: 'photo_caption',
  MEDIA: 'media',
  DATA_PRIVACY_POLICY: 'data_privacy_policy',
  PHOTOGALLERY_CONSENT: 'photogallery_consent',
  MARKETING_CONSENT: 'marketing_consent',
  TERMS_AND_CONDITIONS: 'terms_and_conditions',
  TRANSFER_CONSENT: 'transfer_consent',
  CAPTCHA: 'g-recaptcha-response',
  LANGUAGE: 'language',
  AGE_STATEMENT: 'age_statement',
  PROFESSION_STATEMENT: 'profession_statement',
  PRODUCT_STATEMENT: 'product_statement',
  PHONE_CODE: 'phone_code',
  PHONE_NUMBER: 'phone_number',
  SCREENSHOTTER_NAME: 'screenshotter_name',
  SCREENSHOT_LOCATION: 'screenshot_location',
  GAMING_NICKNAME: 'gaming_nickname',
};
